import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { retry, timer } from 'rxjs';
import { environment } from 'environments/environment';
import { isRetriable, retryDelayMs, MAX_RETRY_ATTEMPTS } from './retry-policy';

/**
 * Tries a failed read again before anyone hears about it.
 *
 * Stations run on cellular data, so a drop of a second or two is ordinary rather than exceptional.
 * Without this, each one surfaces as a toast that interrupts the line for a condition that has
 * already fixed itself. Only safe methods are retried — see {@link isRetriable} for why that
 * restriction is load-bearing rather than cautious.
 *
 * Registered after the error interceptor so it sits closer to the network: a failure is retried
 * here first, and only a final failure travels outward to be reported.
 */
export const retryInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    retry({
      count: MAX_RETRY_ATTEMPTS,
      delay: (error: unknown, attempt: number) => {
        const status = error instanceof HttpErrorResponse ? error.status : -1;
        if (!req.url.startsWith(environment.apiUrl) || !isRetriable(req.method, status)) {
          throw error;
        }

        return timer(retryDelayMs(attempt));
      },
    }),
  );
